<template>
  <div>
    <h1>欢迎来到首页</h1>
    <button @click="checkLogin">检查登录状态</button>
  </div>
</template>
  
  <script>
import { useRouter } from "vue-router";
import { getCurrentInstance } from 'vue';
import { ref } from 'vue';

export default {
  name: "homeIndex",
  setup() {
    const router = useRouter(); // 获取路由实例

    // 使用ref创建响应式引用
    const token = ref(null);
    const { proxy } = getCurrentInstance();
    
    const checkLogin = async () => {
        token.value = localStorage.getItem("token"); // 从缓存中获取token
        token.value = token.value || null;
      if (token.value) {
        // 如果有token，调用后端接口验证
        const url = "/login/checkLoginStatus";
        proxy.$tools
          .request(url, { reqBody: {} })
          .then((response) => {
            const returnCode = response.data.rspHead.reurnCode;
            if (!"000000" === returnCode) {
              router.push("/error");
            }
            const status = response.data.rspBody.status;
            if ("1" === status) {
            //   const rsptoken = response.data.rspBody.token;
            //   window.sessionStorage.setItem("token", rsptoken); // 存储token
            } else {
              router.push("/appLogin");
            }
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
      } else {
        // 如果没有token，重定向到登录页面
        router.push("/appLogin");
      }
    };

    return {
      // 将方法暴露给模板
      checkLogin,
    };
  },
};
</script>
  
  <style scoped>
.container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.logo {
  max-width: 100%;
  height: auto;
}

.form-container {
  margin-top: 20px;
}

input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
  